/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutOrganizationsWithAccounts200Response
 */
export interface PutOrganizationsWithAccounts200Response {
    /**
     * アップサート対象のアカウントID一覧（inserted+delete）
     * @type {Array<string>}
     * @memberof PutOrganizationsWithAccounts200Response
     */
    accountIds: Array<string>;
    /**
     * 新規追加されたアカウントID一覧
     * @type {Array<string>}
     * @memberof PutOrganizationsWithAccounts200Response
     */
    inserted: Array<string>;
    /**
     * 削除されたアカウントID一覧
     * @type {Array<string>}
     * @memberof PutOrganizationsWithAccounts200Response
     */
    deleted: Array<string>;
}

/**
 * Check if a given object implements the PutOrganizationsWithAccounts200Response interface.
 */
export function instanceOfPutOrganizationsWithAccounts200Response(value: object): value is PutOrganizationsWithAccounts200Response {
    if (!('accountIds' in value) || value['accountIds'] === undefined) return false;
    if (!('inserted' in value) || value['inserted'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function PutOrganizationsWithAccounts200ResponseFromJSON(json: any): PutOrganizationsWithAccounts200Response {
    return PutOrganizationsWithAccounts200ResponseFromJSONTyped(json, false);
}

export function PutOrganizationsWithAccounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutOrganizationsWithAccounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'accountIds': json['account_ids'],
        'inserted': json['inserted'],
        'deleted': json['deleted'],
    };
}

export function PutOrganizationsWithAccounts200ResponseToJSON(json: any): PutOrganizationsWithAccounts200Response {
    return PutOrganizationsWithAccounts200ResponseToJSONTyped(json, false);
}

export function PutOrganizationsWithAccounts200ResponseToJSONTyped(value?: PutOrganizationsWithAccounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_ids': value['accountIds'],
        'inserted': value['inserted'],
        'deleted': value['deleted'],
    };
}

